import React from "react";

export const inputClass = "mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

export function Field({ label, hint, children }: { label: string; hint?: string; children: React.ReactNode }) {
    return <label className="block text-sm font-bold text-slate-700">{label}{children}{hint && <span className="mt-1 block text-xs font-normal text-slate-500">{hint}</span>}</label>;
}

export function TextField({ label, value, onChange, type = "text", required, placeholder, hint }: {
    label: string; value: string | number; onChange: (value: string) => void; type?: string; required?: boolean; placeholder?: string; hint?: string;
}) {
    return <Field label={label} hint={hint}><input className={inputClass} type={type} value={value} required={required} placeholder={placeholder} onChange={(event) => onChange(event.target.value)} /></Field>;
}

export function Toggle({ label, checked, onChange }: { label: string; checked: boolean; onChange: (checked: boolean) => void }) {
    return <label className="flex items-center gap-2 text-sm font-semibold text-slate-700"><input type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} className="h-4 w-4 rounded border-slate-300 text-blue-600" />{label}</label>;
}

